// extracted by mini-css-extract-plugin
export default {"root":"Custom_root__fATq5","workspace":"Custom_workspace__cplpg","canvasContainer":"Custom_canvasContainer__CjJgC","canvas":"Custom_canvas__Zn4Kk"};